/**
 * Formats the displayed value of an HTMLInputElement instance.
 * Applies events to constrain the number of decimals input and applies formatting on input.
 * @param input The input eleent.
 * @param isOnInput Optional flag determining whether the call is from an oninput event handler or not.
 */
export function formatNumericInput(input: HTMLInputElement, isOnInput?: boolean) {

	// get caret pos as we may need to restore this later
	let stringValue = input.value;
	const originalCaretPos = input.selectionStart ?? stringValue.length;

	const decimalsAttr = input.getAttribute("data-decimals");
	const allowedDecimals = decimalsAttr ? parseInt(decimalsAttr) : 2;

	// decimal handling
	let decimalIndex: number;
	if ((decimalIndex = stringValue.indexOf('.')) > -1) {

		let segments = stringValue.split('.');

		// undo multiple decimal point input
		if (segments.length > 2) {
			const withoutDecs = segments.join('');
			stringValue = `${withoutDecs.slice(0, decimalIndex)}.${withoutDecs.slice(decimalIndex)}`;
			input.value = stringValue;
		}

		// if there were multiple decimal places get segments again
		if (segments.length > 2) {
			segments = input.value.split('.');
		}

		// constrain the number of decimals input
		if (segments.length == 2 && segments[1].length > allowedDecimals) {
			stringValue = `${segments[0]}.${segments[1].slice(0, allowedDecimals)}`;
			input.value = stringValue;
		}
	}

	// if there is a value format it
	// if this is oninput then don't format if in the middle of writing the decimal portion
	if (stringValue && (!isOnInput || !(input.value.endsWith(".")))) {

		const value = parseFloat(stringValue.replace(/[^0-9\.]+/g, ""));

		if (!isNaN(value)) {
			// following ensures formatted input has correct trailing fractional 0 on blur
			let formatted = value.toLocaleString(undefined, { minimumFractionDigits: isOnInput ? undefined : allowedDecimals });
			if (isOnInput && decimalIndex > -1 && formatted.indexOf(".") === -1 || (stringValue.endsWith("0") && !formatted.endsWith("0"))) {
				// ensure trailing zeros in decimal value
				formatted = formatted.split(".")[0] + "." + stringValue.split(".")[1];
			}
			input.value = formatted;
		}

		// restore caret pos if oninput
		if (isOnInput) {
			const newCaretPos = input.value.length - stringValue.length + originalCaretPos;
			input.setSelectionRange(newCaretPos, newCaretPos);
		}
	}
}